import axiosClient from "../axiosClient"

const getToken = () => {
    return (localStorage?.auth && JSON.parse(localStorage.auth)?.accessToken) || undefined;
}

const getProducts = (params) => {
    return axiosClient.get("product-group", {
        params,
        headers: {
            Authorization: "Bearer " + getToken()
        }
    })
}
const getProductDetail = (id) => {
    return axiosClient.get("product-group/" + id, {
        headers: {
            Authorization: "Bearer " + getToken()
        }
    })
}
const getProductsByUnit = (params) => {
    return axiosClient.get("products-detail", {
        params,
        headers: {
            Authorization: "Bearer " + getToken()
        }
    })
}

const postProduct = (data) => {
    return axiosClient.post("product-group", data, {
        headers: {
            Authorization: "Bearer " + getToken()
        }
    })
}

const putProduct = (data) => {
    return axiosClient.put("product-group/" + data.id, data.values, {
        headers: {
            Authorization: "Bearer " + getToken()
        }
    })
}

const putProductStatus = (id, data) => {
    return axiosClient.put("products-status/" + id, data, {
        headers: {
            Authorization: "Bearer " + getToken()
        }
    })
}

export {
    getProducts,
    getProductDetail,
    postProduct,
    putProduct,
    putProductStatus,
    getProductsByUnit
}